import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import HttpClientXml from "../utils/HttpClientXml";
import HomeService from "../Services/HomeService";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "rgb(131, 144, 155)",
  margin: "0px 0px 10px 0px",
  fontWeight: "bold",
};

function AddReels() {
  const userCity = localStorage.getItem("city");
  const [cities, setCities] = useState([]);
  const [formData, setFormData] = useState({
    city: "",
    thumbnail: "",
    video: "",
    description: "",
  });
  const [thumbnailLoading, setThumbnailLoading] = useState(false);
  const [videoLoading, setVideoLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          // Filter cities if user has city restriction
          setCities([res.data.find((item) => item._id === userCity)]);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      toast.error("Failed to fetch cities");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleThumbnailUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate image file
    if (!file.type.startsWith("image/")) {
      toast.error("Please select a valid image file for thumbnail");
      return;
    }

    // // Validate image size
    // const maxSize = 10 * 1024 * 1024; // 10MB
    // if (file.size > maxSize) {
    //   toast.error("Image size should be less than 10MB");
    //   return;
    // }

    setThumbnailLoading(true);

    const data = new FormData();
    data.append("image", file);

    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setFormData((prev) => ({ ...prev, thumbnail: res.image }));
        toast.success("Thumbnail uploaded successfully!");
      } else {
        toast.error(res?.message || "Failed to upload thumbnail");
      }
    } catch (error) {
      toast.error("Failed to upload thumbnail.");
      console.error("Error uploading thumbnail:", error);
    } finally {
      setThumbnailLoading(false);
    }
  };

  const handleVideoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate video file
    if (!file.type.startsWith("video/")) {
      toast.error("Please select a valid video file");
      return;
    }

    // // Validate video size
    // const maxSize = 50 * 1024 * 1024; // 50MB
    // if (file.size > maxSize) {
    //   toast.error("Video size should be less than 50MB");
    //   return;
    // }

    setVideoLoading(true);

    const data = new FormData();
    data.append("image", file); // Assuming your endpoint handles videos as "image"

    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setFormData((prev) => ({ ...prev, video: res.image }));
        toast.success("Video uploaded successfully!");
      } else {
        toast.error(res?.message || "Failed to upload video");
      }
    } catch (error) {
      toast.error("Failed to upload video.");
      console.error("Error uploading video:", error);
    } finally {
      setVideoLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.city) {
      toast.error("Please select a city");
      return;
    }

    if (!formData.thumbnail) {
      toast.error("Please upload a thumbnail image.");
      return;
    }

    if (!formData.video) {
      toast.error("Please upload a video.");
      return;
    }

    if (!formData.description.trim()) {
      toast.error("Please enter a description for the reel.");
      return;
    }

    setLoading(true);

    // Prepare data according to new Postman body structure
    const reelData = {
      city: formData.city,
      thumbnail: formData.thumbnail,
      video: formData.video,
      description: formData.description,
    };

    console.log("Reel Data:", reelData);

    try {
      const res = await HomeService.addReel(reelData);
      if (res?.status) {
        toast.success("Reel added successfully!");
        clearForm();
        navigate("/manage-reels");
      } else {
        toast.error(res?.message || "Failed to add reel.");
      }
    } catch (error) {
      toast.error("Failed to add reel.");
      console.error("Error adding reel:", error);
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    setFormData({
      city: "",
      thumbnail: "",
      video: "",
      description: "",
    });
  };

  const removeThumbnail = () => {
    setFormData((prev) => ({ ...prev, thumbnail: "" }));
    toast.success("Thumbnail removed");
  };

  const removeVideo = () => {
    setFormData((prev) => ({ ...prev, video: "" }));
    toast.success("Video removed");
  };

  useEffect(() => {
    fetchCities();
  }, []);

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add Reels
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* City Selection */}
                <div className="col-md-6 mt-3">
                  <label>
                    City<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>
                      ---Select City---
                    </option>
                    {cities.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                  <div className="form-text">Select the city for this reel</div>
                </div>

                {/* Thumbnail Upload Section */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="thumbnail">
                    Upload Thumbnail<span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    id="thumbnail"
                    className="form-control"
                    onChange={handleThumbnailUpload}
                    accept="image/*"
                    disabled={thumbnailLoading}
                    required
                  />
                  <div className="form-text">
                    {thumbnailLoading ? (
                      <span className="text-primary">
                        <i className="fa-solid fa-spinner fa-spin me-1"></i>
                        Uploading thumbnail...
                      </span>
                    ) : (
                      "Upload a thumbnail image for the reel"
                    )}
                  </div>

                  {formData.thumbnail && (
                    <div className="mt-3 position-relative">
                      <div className="alert alert-success p-2">
                        <strong>Thumbnail Preview:</strong>
                      </div>
                      <img
                        src={formData.thumbnail}
                        alt="Thumbnail Preview"
                        style={{
                          maxHeight: "200px",
                          maxWidth: "100%",
                          borderRadius: "8px",
                          border: "2px solid #dee2e6",
                        }}
                      />
                      <button
                        type="button"
                        onClick={removeThumbnail}
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: "35px", right: "10px" }}
                      >
                        <i className="fa-solid fa-times"></i>
                      </button>
                    </div>
                  )}
                </div>

                {/* Video Upload Section */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="video">
                    Upload Video<span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    id="video"
                    className="form-control"
                    onChange={handleVideoUpload}
                    accept="video/*"
                    disabled={videoLoading}
                    required
                  />
                  <div className="form-text">
                    {videoLoading ? (
                      <span className="text-primary">
                        <i className="fa-solid fa-spinner fa-spin me-1"></i>
                        Uploading video...
                      </span>
                    ) : (
                      "Upload a video file for the reel"
                    )}
                  </div>

                  {formData.video && (
                    <div className="mt-3 position-relative">
                      <div className="alert alert-success p-2">
                        <strong>Video Preview:</strong>
                      </div>
                      <video
                        controls
                        style={{
                          maxHeight: "200px",
                          maxWidth: "100%",
                          borderRadius: "8px",
                          border: "2px solid #dee2e6",
                        }}
                      >
                        <source src={formData.video} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                      <button
                        type="button"
                        onClick={removeVideo}
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: "35px", right: "10px" }}
                      >
                        <i className="fa-solid fa-times"></i>
                      </button>
                    </div>
                  )}
                </div>

                {/* Description Textarea */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="description">
                    Description<span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="description"
                    className="form-control"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Enter reel description..."
                    required
                    style={{ height: "172px" }}
                  ></textarea>
                  <div className="form-text">
                    Enter a description for the reel
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="row mt-4">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    disabled={loading || thumbnailLoading || videoLoading}
                  >
                    {loading ? (
                      <>
                        <i className="fa-solid fa-spinner fa-spin me-2"></i>
                        Adding Reel...
                      </>
                    ) : (
                      "Add Reel"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddReels;
